export enum MembershipTierFrequencyEnum {
	Weekly = 'weekly',
	Monthly = 'monthly',
	Quarterly = 'quarterly',
	SemiAnnual = 'semi-annual',
	Annual = 'annual',
	OneTime = 'one-time',
}
